export const INCREMENT_TIME_COUNTER = 'INCREMENT_TIME_COUNTER'
